import decode from 'jwt-decode';
import LogService from "../services/LogService";
import IEvent from "../types/Event";
import ILog from "../types/Log";
import IOutOffice from "../types/OutOffice";
import IConfig from "../types/Config";
import { IRegistroJornada } from "../types/Jornada";
import ISala from '../types/Sala';
import Utilities from '../common/Utilities';
import IActividad from '../types/Actividad';
import IHoliday from '../types/Holiday';
import IEntidadFacturacion from '../types/EntidadFacturacion';
import { HolidaysTypes } from 'date-holidays';
import * as constantes from "../common/Constantes";

const formatOutOffice = (data: IOutOffice[]): IEvent[] => {
    try {
        const formattedOutOffices: IEvent[] = [];

        if (data.length === 0) return formattedOutOffices;

        data.map(x => {

            let formattedOutOffice: IEvent = {
                id: x._id,
                title: `NO DISPONIBLE - ${getEmpleados().filter((z: any) => z.internalID === x.especialistaId)[0]?.firstName != undefined ? getEmpleados().filter((z: any) => z.internalID === x.especialistaId)[0]?.firstName : ''}`,
                start: new Date(x.start),
                end: new Date (x.end),
                resource: {  }
            };
            formattedOutOffices.push(formattedOutOffice);
            return formattedOutOffice;
        });
        return formattedOutOffices;
    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.formatOutOffice', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return [];
    }
};

const addConfig = (configType: string, newConfig: any) => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);

        if (configType === 'mail') {
            config.mail = newConfig;
            localStorage.setItem(constantes.LS_config, JSON.stringify(config));
            return;
        }
        if (configType === 'asistenciaDoc') {
            config.asistenciaDoc = newConfig;
            localStorage.setItem(constantes.LS_config, JSON.stringify(config));
            return;
        }
        if (configType === 'consentimientoDoc') {
            config.consentimientoDoc = newConfig;
            localStorage.setItem(constantes.LS_config, JSON.stringify(config));
            return;
        }
        if (configType === 'currency') {
            config.currency = newConfig;
            localStorage.setItem(constantes.LS_config, JSON.stringify(config));
            return;
        }
        if (configType === 'datosFacturacion') {
            config.datosFacturacion = newConfig;
            localStorage.setItem(constantes.LS_config, JSON.stringify(config));
            return;
        }

        type ObjectKey = keyof typeof config;
        const prop = configType as ObjectKey;
        config[prop].push(newConfig);
        localStorage.setItem(constantes.LS_config, JSON.stringify(config));
    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.addConfig', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
    }
    
};

const editConfig = (configType: string, newConfig: any) => {
    try {
        let config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (configType === 'clinicName') {
            config.clinicName = newConfig;
            localStorage.setItem(constantes.LS_config, JSON.stringify(config));
            return;
        } else if (configType === 'clinicCity') {
            config.clinicCity = newConfig;
            localStorage.setItem(constantes.LS_config, JSON.stringify(config));
            return; 
        } else if (configType === 'clinicProvincia') {
            config.clinicProvincia = newConfig;
            localStorage.setItem(constantes.LS_config, JSON.stringify(config));
            return;
        } else if (configType === 'mail') {
            config.mail = newConfig;
            localStorage.setItem(constantes.LS_config, JSON.stringify(config));
            return;
        } else if (configType === 'clinicDomicilio') {
            config.clinicDomicilio = newConfig;
            localStorage.setItem(constantes.LS_config, JSON.stringify(config));
            return;
        } else if (configType === 'clinicEmail') {
            config.clinicEmail = newConfig;
            localStorage.setItem(constantes.LS_config, JSON.stringify(config));
            return;
        } else if (configType === 'clinicTelefono') {
            config.clinicTelefono = newConfig;
            localStorage.setItem(constantes.LS_config, JSON.stringify(config));
            return;
        } else if (configType === 'consentimientoDoc') {
            config.consentimientoDoc = newConfig;
            localStorage.setItem(constantes.LS_config, JSON.stringify(config));
            return;
        } else if (configType === 'clinicLogo') {
            config.clinicLogo = newConfig;
            localStorage.setItem(constantes.LS_config, JSON.stringify(config));
            return;
        } else if (configType === 'clinicColor') {
            config.clinicColor = newConfig;
            localStorage.setItem(constantes.LS_config, JSON.stringify(config));
            return;
        } else if (configType === 'asistenciaDoc') {
            config.asistenciaDoc = newConfig;
            localStorage.setItem(constantes.LS_config, JSON.stringify(config));
            return;
        } else if (configType === 'isFacturacionReady') {
            config.isFacturacionReady = newConfig;
            localStorage.setItem(constantes.LS_config, JSON.stringify(config));
            return;
        } else if (configType === 'reminders') {
            config.reminders = newConfig;
            localStorage.setItem(constantes.LS_config, JSON.stringify(config));
            return;
        } else if (configType === 'overlap') {
            config.overlap = newConfig;
            localStorage.setItem(constantes.LS_config, JSON.stringify(config));
            return;
        } else if (configType === 'agenda') {
            config.agenda = newConfig;
            localStorage.setItem(constantes.LS_config, JSON.stringify(config));
            return; 
        } else if (configType === 'waConfig') {
            config.waConfig = newConfig;
            localStorage.setItem(constantes.LS_config, JSON.stringify(config));
            return;
        }

        type ObjectKey = keyof typeof config;
        const prop = configType as ObjectKey;
        const x = [newConfig, ...config[prop].filter((u: any) => u._id !== newConfig._id)];
        //Sort segun types
        if (configType === 'users' || configType === 'actividades' || configType === 'salas' || configType === 'servicios' || configType === 'metodosPago') {
            x.sort((a: any,b: any) => {
                return a.internalID - b.internalID;
            });
        }
        config[prop] = x;
        localStorage.setItem(constantes.LS_config, JSON.stringify(config));
    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.editConfig', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
    }
};

const editFestivos = (festivos: IHoliday[]) => {
    try {
        let config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        config.holidays = festivos;
        localStorage.setItem(constantes.LS_config, JSON.stringify(config));
    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.editFestivos', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
    }
}

const deleteConfig = (configType: string, id: string | null | undefined) => {
    try {
        if (id === undefined) return;
        
        let config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        type ObjectKey = keyof typeof config;
        const prop = configType as ObjectKey;

        if (id === null) {
            //Se borra todo
            config[prop] = [];
            localStorage.setItem(constantes.LS_config, JSON.stringify(config));
            return;
        }

        if (id === '') {
            //Se elemina el justificante de asistencia
            config[prop] = null;
            localStorage.setItem(constantes.LS_config, JSON.stringify(config));
            return;
        }
        
        const x = [...config[prop].filter((u: any) => u._id !== id)];
        config[prop] = x;
        localStorage.setItem(constantes.LS_config, JSON.stringify(config));
    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.deleteConfig', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
    }
};

const getCurrentUser = () => {
    try {
        const user = JSON.parse(localStorage.getItem(constantes.LS_profile)!);
        if (!user) return null;

        const token = user?.token;
        const decodedToken: any = decode(token);

        if (decodedToken.exp * 1000 < new Date().getTime()) {
            return null;
        } else {
            return user;
        }
    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getCurrentUser', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
    }
};

const getCurrentUserId = () => {
    try {
        const user = JSON.parse(localStorage.getItem(constantes.LS_profile)!);
        if (!user) return null;

        const token = user?.token;
        const decodedToken: any = decode(token);

        if (decodedToken.exp * 1000 < new Date().getTime()) {
            return null;
        } else {
            return decodedToken.id;
        }
    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getCurrentUserId', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
    }
};

const getUserId = () => {
    try {
        const user = JSON.parse(localStorage.getItem(constantes.LS_profile)!);
        const token = user?.token;
        if (token) {
            const decodedToken: any = decode(token);
            if (decodedToken.internalID === 0) {
                return decodedToken.id;
            } else {
                return decodedToken.userId;
            }
        }
    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getUserId', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
    }
};

const getUserRole = () => {
    try {
        const user = JSON.parse(localStorage.getItem(constantes.LS_profile)!);
        const token = user?.token;
        if (token) {
            const decodedToken: any = decode(token);
            return decodedToken.role;
        }
    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getUserRole', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
    }
};

const isFacturacionReady = () => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config) return false;
        return config.isFacturacionReady;
    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.isFacturacionReady', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
    }
};

const getUserInternalId = () => {
    try {
        const user = JSON.parse(localStorage.getItem(constantes.LS_profile)!);
        const token = user?.token;
        if (token) {
            const decodedToken: any = decode(token);
            return decodedToken.internalID;
        }
    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getUserInternalId', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
    }
};

const getUserEmail = () => {
    try {
        const user = JSON.parse(localStorage.getItem(constantes.LS_profile)!);
        const token = user?.token;
        if (token) {
            const decodedToken: any = decode(token);
            return decodedToken.email;
        }
    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getUserEmail', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
    }
};

const getEmpleados = () => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config) return [];
        return config.users;

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getCurrentEmpleados', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return [];
    }
};

const getSanitarios = () => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config) return [];
        return config.users.filter((u: any) => u.role !== 2);

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getSanitarios', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return [];
    }
};

const getOutOffices = () => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config) return [];
        return config.outoffices;

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getOutOffices', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return [];
    }
};

const getClinicName = () => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config) return '';
        return config.clinicName;

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getClinicName', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return '';
    }
};

const getClinicCity = () => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config) return '';
        return config.clinicCity;

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getClinicCity', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return '';
    }
}

const getClinicDomicilio = () => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config) return '';
        return config.clinicDomicilio == undefined ? '' : config.clinicDomicilio;

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getClinicDomicilio', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return '';
    }
}

const getClinicEmail = () => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config) return '';
        return config.clinicEmail == undefined ? '' : config.clinicEmail;

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getClinicEmail', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return '';
    }
}

const getClinicTelefono = () => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config) return '';
        return config.clinicTelefono == undefined ? '' : config.clinicTelefono;

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getClinicTelefono', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return '';
    }
}

const getProvincia = () => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config) return '';
        return config.clinicProvincia;

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getProvincia', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return '';
    }
};

const getActividades = () => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config) return [];
        return config.actividades;

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getActividades', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return [];
    }
};

const getSalas = () => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config) return [];
        return config.salas;

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getSalas', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return [];
    }
};

const getServicios = () => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config) return [];
        return config.servicios ?? [];

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getServicios', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return [];
    }
};

const getBonos = () => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config) return [];
        return config.bonos ?? [];

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getBonos', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return [];
    }
};

const getDatosFacturacion = () => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config) return null;
        return config.datosFacturacion ?? null;

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getDatosFacturacion', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return null;
    }
};

// Lista completa de secundarias: un cambio de titular puede intercambiar la principal con una o añadir otra desactivada.
const setDatosFacturacionAdicional = (entidades: IEntidadFacturacion[]) => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config) return;
        config.datosFacturacionAdicional = entidades;
        localStorage.setItem(constantes.LS_config, JSON.stringify(config));
    } catch (e: unknown) {
        const message = e instanceof Error ? e.message : String(e);
        const error: ILog = { method: 'Utils.Config.setDatosFacturacionAdicional', level: 'error', message, meta: message };
        LogService.logError(error);
    }
};

// Entidad que puede facturar: la principal siempre; una secundaria solo si está activa (una desactivada no emite, ni
// sus bonos se pueden usar hasta activarla).
const isEntidadActiva = (entidadId?: string | null): boolean =>
    !entidadId || getDatosFacturacionAdicional().some((e: IEntidadFacturacion) => e._id === entidadId && e.active);

const getDatosFacturacionAdicional = () => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config) return [];
        return config.datosFacturacionAdicional ?? [];

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getDatosFacturacionAdicional', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return [];
    }
};

const getMetodosPago = () => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config) return [];
        return config.metodosPago ?? [];

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getMetodosPago', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return [];
    }
};

const updateSalas = (salas: ISala[], idActividad: string | undefined | null) => {
    try {
        if (Utilities.isNullEmptyUndefined(idActividad)) return [];

        salas.map((sala: ISala) => {
            sala.actividades = sala.actividades.filter(a => a !== idActividad);
            return sala;
        });

        return salas;

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.updateSalas', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return [];
    }
};

const getActividadesArray = (actividades: IActividad[]) => {
    try {
        const actividadesArr: string[] = [];
        actividades.map((actividad) => {
            actividadesArr.push(actividad.title.toLowerCase());
            return actividad;
        });

        return actividadesArr;

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getActividadesArray', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return [];
    }
};

const getSalaByActividad = (salas: ISala[], actividad: IActividad) => {
    try {
        let result: string = '';
        salas.map((s) => {
            if (!actividad._id) return s;
            if (s.actividades.includes(actividad._id)) {
                if (s.internalID === null || s.internalID === undefined) return s;
                result = s.internalID;
            }
            return s;
        });
        return result;

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getSalaByActividad', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
    }
};

const getHolidays = () => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config) return [];
        return config.holidays;

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getHolidays', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return [];
    }
};

const getMail = () => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config) return undefined;
        return config.mail;

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getMail', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return undefined;
    }
};

const getClinicColor = () => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config) return '#000000';
        return config.clinicColor ? config.clinicColor : '#000000';

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getClinicColor', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return '#000000';
    }
};

const getClinicLogo = () => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config) return null;
        return config.clinicLogo ? config.clinicLogo : null;

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getClinicLogo', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return null;
    }
};

const getUserCurrency = () => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config) return null;
        return config.currency ? config.currency : 'EUR';

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getUserCurrency', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return null;
    }
}

const getPais = () => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config) return null;
        return config.datosFacturacion?.pais ? config.datosFacturacion.pais : 'ES';

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getPais', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return null;
    }
}

const getAsistenciaDoc = () => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config) return undefined;
        return config.asistenciaDoc;

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getAsistenciaDoc', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return undefined;
    }
};

const getConsentientoDoc = () => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config) return null;
        return config.consentimientoDoc;

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getConsentientoDoc', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return null;
    }
};

const getCitaReminder = () => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config) return null;
        return config.reminders;

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getCitaReminder', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return null;
    }
};

const getWaConfig = () => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config) return null;
        return config.waConfig;

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getWaConfig', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return null;
    }
};

// Registro de jornada de la persona que ha iniciado sesión (null si la configuración es de antes del módulo)
const getRegistroJornada = (): IRegistroJornada | null => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        return config?.registroJornada ?? null;
    } catch (e: unknown) {
        const error: ILog = { method: 'Utils.Config.getRegistroJornada', level: 'error', message: (e as Error).message, meta: (e as Error).message };
        LogService.logError(error);
        return null;
    }
};

// Misma regla que la API: se ve si puede fichar o tiene registros; el admin, también si el módulo está activo o la clínica
// tiene registros
const verSeccionJornada = (r: IRegistroJornada) =>
    r.puedeFichar || r.tieneRegistros === true || (r.esAdmin && (r.activo || r.clinicaTieneRegistros === true));

// El admin acaba de activar o desactivar el módulo: se refleja en su propia configuración (la sección y el switch). A los
// demás les llega al volver a iniciar sesión.
const setRegistroJornadaActivo = (activo: boolean) => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config?.registroJornada) return;
        const registro = config.registroJornada;
        const puedeFichar = activo && registro.puedeFichar;
        config.registroJornada = { ...registro, activo, puedeFichar, verSeccion: verSeccionJornada({ ...registro, activo, puedeFichar }) };
        localStorage.setItem(constantes.LS_config, JSON.stringify(config));
    } catch (e: unknown) {
        const error: ILog = { method: 'Utils.Config.setRegistroJornadaActivo', level: 'error', message: (e as Error).message, meta: (e as Error).message };
        LogService.logError(error);
    }
};

// El admin acaba de cambiar si él mismo ficha: se refleja en su configuración (la pestaña Mi jornada y el icono). Con el
// módulo activo el plan es válido (no se puede bajar a Starter con el módulo activo).
const setRegistroJornadaFicha = (ficha: boolean) => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config?.registroJornada) return;
        const registro = config.registroJornada;
        const puedeFichar = registro.activo && ficha;
        config.registroJornada = { ...registro, ficha, puedeFichar, verSeccion: verSeccionJornada({ ...registro, ficha, puedeFichar }) };
        localStorage.setItem(constantes.LS_config, JSON.stringify(config));
    } catch (e: unknown) {
        const error: ILog = { method: 'Utils.Config.setRegistroJornadaFicha', level: 'error', message: (e as Error).message, meta: (e as Error).message };
        LogService.logError(error);
    }
};

const getOverlapCalendar = () => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config) return null;
        return config.overlap;

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getOverlapCalendar', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return null;
    }
};

const getConfigAgenda = () => {
    try {
        const config: IConfig = JSON.parse(localStorage.getItem(constantes.LS_config)!);
        if (!config) return null;
        return config.agenda;

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.getConfigAgenda', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return null;
    }
};

const formatHolidays = (holidays: HolidaysTypes.Holiday[]) => {
    try {
        const festivos: IHoliday[] = [];
        holidays.map((h) => {
            festivos.push({ start: new Date(h.start), end: new Date(h.end), name: h.name, userId: getUserId() });
        });
        return festivos;

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.formatHolidays', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return [];
    }
};

const formatEvents = (holidays: IHoliday[]): IEvent[] => {
    try {
        const festivos: IEvent[] = [];
        holidays.map((h, index) => {
            festivos.push({ id: h._id ? h._id : index, title: h.name, allDay: true, start: new Date(h.start), end: new Date(h.end), resource: null });
        });
        return festivos;

    } catch (e: any) {
        const error: ILog = { method: 'Utils.Config.toEvents', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return [];
    }
};

// Compara solo la fecha (año/mes/día), no el instante exacto: un festivo importado de
// otro país ancla su hora a la zona horaria de ese país (p.ej. America/Panama), no a la
// del navegador, así que comparar con .getTime() falla salvo que ambas zonas coincidan.
const isSameLocalDay = (a: Date, b: Date): boolean =>
    a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

const ConfigUtils = {
    formatOutOffice,
    addConfig,
    editConfig,
    editFestivos,
    deleteConfig,
    getEmpleados,
    getSanitarios,
    getOutOffices,
    getCurrentUser,
    getCurrentUserId,
    getUserId,
    getUserRole,
    getUserInternalId,
    getUserEmail,
    getClinicName,
    getClinicCity,
    getClinicDomicilio,
    getClinicEmail,
    getClinicTelefono,
    getProvincia,
    getActividades,
    getServicios,
    getBonos,
    getDatosFacturacion,
    getDatosFacturacionAdicional,
    setDatosFacturacionAdicional,
    isEntidadActiva,
    getMetodosPago,
    getSalas,
    updateSalas,
    getActividadesArray,
    getSalaByActividad,
    getHolidays,
    formatHolidays,
    formatEvents,
    isSameLocalDay,
    getMail,
    getClinicColor,
    getClinicLogo,
    getAsistenciaDoc,
    getConsentientoDoc,
    getCitaReminder,
    getWaConfig,
    getRegistroJornada,
    setRegistroJornadaActivo,
    setRegistroJornadaFicha,
    getOverlapCalendar,
    getConfigAgenda,
    isFacturacionReady,
    getUserCurrency,
    getPais
};

export default ConfigUtils;